module.exports = __webpack_public_path__ + "img/CasinoChangeName_d49713e1363a4a5192d5b459c92bb689_20211014003857.c2851152.jpg";